'use strict';

class Panel extends Widget {
  _element: any;

  constructor(element: any) {
    super(element);
  }

  static Create() {
    return $('<div class="panel" />');
  }
}

ui.Panel = Panel;
ui.panel = ui.widgetConstructor('panel', ui.Panel);
